<template>
  <div class="pb-20">
    <h1 class="text-4xl uppercase text-center pb-1.5 md:pb-3.5 md:pt-6">PRIVACY POLICY</h1>
    <hr />
    <div class="text-center py-7">
      <div class="ql-snow text-left mb-24">
        <div class="ql-editor">
          <div class="mb-4" v-html="privacy"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useDomainStore} from "@/stores/main";
import {computed} from "vue";
import {useHead} from "nuxt/app";

const domainStore = useDomainStore();
const privacy = computed(() => domainStore.privacy);
const title = computed(() => domainStore.title);

useHead({
  title: 'Privacy Policy' + ' - ' + title.value,
  meta: [
    {name: 'description', content: 'Privacy Policy'},
    {name: 'keywords', content: 'privacy policy,privacy,policy'}
  ],
})
</script>
